import api from './api';

/**
 * Buscar todas as disciplinas disponíveis
 */
export const getDisciplinasDisponiveis = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.extensao) params.append('extensao', filters.extensao);
    
    const response = await api.get(`/lancamento-notas/disciplinas?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar disciplinas:', error);
    throw error;
  }
};

/**
 * Buscar cursos de uma disciplina
 */
export const getCursosPorDisciplina = async (disciplinaId) => {
  try {
    const response = await api.get(`/lancamento-notas/disciplinas/${disciplinaId}/cursos`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar cursos:', error);
    throw error;
  }
};

/**
 * Buscar extensões disponíveis
 */
export const getExtensoesPorDisciplina = async (disciplinaId) => {
  try {
    const response = await api.get(`/lancamento-notas/disciplinas/${disciplinaId}/extensoes`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar extensões:', error);
    throw error;
  }
};

/**
 * Buscar alunos de uma disciplina com filtros
 */
export const getAlunosPorDisciplina = async (disciplinaId, filters = {}) => {
  try {
    const params = new URLSearchParams({
      disciplina: disciplinaId,
      ...(filters.curso && { curso: filters.curso }),
      ...(filters.extensao && { extensao: filters.extensao }),
      ...(filters.page && { page: filters.page }),
      ...(filters.limit && { limit: filters.limit }),
      ...(filters.search && { search: filters.search }),
      ...(filters.skipCount && { skipCount: 'true' })
    });

    const response = await api.get(`/lancamento-notas/alunos?${params}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar alunos:', error);
    throw error;
  }
};

/**
 * Buscar estatísticas de uma disciplina
 */
export const getEstatisticasDisciplina = async (disciplinaId, filters = {}) => {
  try {
    const params = new URLSearchParams({
      disciplina: disciplinaId,
      ...(filters.curso && { curso: filters.curso }),
      ...(filters.extensao && { extensao: filters.extensao })
    });

    const response = await api.get(`/lancamento-notas/estatisticas?${params}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar estatísticas:', error);
    throw error;
  }
};

/**
 * Atualizar nota individual
 */
export const atualizarNota = async (id, dados) => {
  try {
    const response = await api.put(`/lancamento-notas/${id}`, dados);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar nota:', error);
    throw error;
  }
};

/**
 * Atualizar notas em lote
 */
export const atualizarNotasLote = async (notas) => {
  try {
    const response = await api.put('/lancamento-notas/lote/atualizar', { notas });
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar notas em lote:', error);
    throw error;
  }
};

/**
 * Buscar extensões do usuário logado
 */
export const getExtensoesUsuario = async () => {
  try {
    const response = await api.get('/usuarios/me/extensoes');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar extensões do usuário:', error);
    throw error;
  }
};

/**
 * Remover nota de um aluno
 */
export const removerNota = async (id) => {
  try {
    const response = await api.delete(`/lancamento-notas/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao remover nota:', error);
    throw error;
  }
};

/**
 * Buscar histórico completo de notas de um aluno
 */
export const getHistoricoNotasAluno = async (idAluno, filters = {}) => {
  try {
    const params = new URLSearchParams({
      ...(filters.extensao && { extensao: filters.extensao }),
      ...(filters.origemExtensao && { origemExtensao: filters.origemExtensao }),
      ...(filters.curso && { curso: filters.curso }),
      ...(filters.disciplina && { disciplina: filters.disciplina }),
      ...(filters.page && { page: filters.page }),
      ...(filters.limit && { limit: filters.limit })
    });

    const response = await api.get(`/lancamento-notas/aluno/${idAluno}/historico?${params}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar histórico de notas:', error);
    throw error;
  }
};
